import { createContext } from "react";
import { ImagesDTO } from "../DTOs/ImagesDTO"; 

type ImageContextType = {
    images: ImagesDTO;
    alterarLogo: (path: string) => void,
};


const finalLogoPath = 'logo.jpg'; 

export const imageInitial = {
    Logo: finalLogoPath 
};

const imageContext = createContext<ImageContextType>({
    images: imageInitial as ImagesDTO, 
    alterarLogo: (path: string) => {}
});


export default imageContext;